import AnimatedGraphicsIcon from './animatedGraphics.svg';
import CustomChartsIcon from './customCharts.svg';
import CustomDiagramsIcon from './customDiagrams.svg';
import DashboardIcon from './dashboard.svg';
import TaskListsIcon from './taskLists.svg';

export { AnimatedGraphicsIcon, CustomChartsIcon, CustomDiagramsIcon, DashboardIcon, TaskListsIcon };
